export function normalizeUrl(url?: string): string {
  if (!url) return ''
  if (url.startsWith('http') || url.startsWith('/')) return url
  if (url.startsWith('//')) return `https:${url}`
  return `/${url}`
}
